import { queryOptions, useQuery } from '@tanstack/react-query'
import * as Crypto from 'expo-crypto'
import { useIntl } from 'react-intl'

import { captureException } from '@/src/config/sentry'
import { authTokenStorage } from '@/src/features/auth/utils/authTokenStorage'

import { donationApi } from '../api/donationApi'

export const donationBannerQueryOptions = (locale: TLocale) =>
  queryOptions({
    queryKey: ['donation_banner', locale],
    queryFn: async ({ signal }) => {
      const token = authTokenStorage.getToken()
      let cacheBuster: string | undefined
      try {
        cacheBuster = token ? await Crypto.digestStringAsync(Crypto.CryptoDigestAlgorithm.SHA256, token) : undefined
      } catch (e) {
        captureException.then((fn) => fn(e))
      }
      return donationApi.getDonationBanner({ signal, cacheBuster })
    },
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    retry: 5,
  })

export const useDonationBannerQuery = () => {
  const { locale } = useIntl()
  return useQuery(donationBannerQueryOptions(locale))
}
